/**
 * P3 i18n gap fix (2026-10-09 retest B4.2/B1.5): the backend still sends some
 * raw, hardcoded messages (plan-limits middleware, home unit-context gate).
 * This FE-side mapper routes the known raw strings through the shared i18n
 * bundles (es-MX + en) instead of hardcoding the display text. Unknown
 * messages pass through unchanged — the backend stays the source of truth;
 * we only translate the strings we can recognize exactly.
 */
import i18next from 'i18next';

/** Exact backend message -> i18n key (src/locales/<lng>/common.json). */
const BACKEND_MESSAGE_KEYS: Record<string, string> = {
  // unit-context.js USUARIOS_ONLY 403 (unaccented, hardcoded backend string)
  'Acceso de propietario no residente: gestion de Usuarios unicamente.':
    'homeTasks.gateNonResidentOwner',
  // home-limits.js plan-gate 403 for tasks (raw English)
  'Free plan tasks limit reached.': 'homeTasks.planLimitTasks',
};

/** Translate a known raw backend message via i18n; pass anything else through. */
export function translateBackendMessage(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const msg = String(raw);
  const key = BACKEND_MESSAGE_KEYS[msg.trim()];
  if (!key) return msg;
  const translated = i18next.t(key, { defaultValue: msg });
  // If the bundle isn't loaded yet (bootstrap race), i18next may echo the key
  // — fall back to the raw message rather than showing a translation key.
  return translated && translated !== key ? translated : msg;
}
